import { useNavigate } from 'react-router';

import { FullPageMessage } from '@/pages/ErrorPage/FullPageMessage';

export const SharedDashboardNotFound = () => {
  const navigate = useNavigate();

  return (
    <FullPageMessage
      buttonLabel='Go to My Dashboard'
      subtitle="Let's create a new one"
      title='This dashboard is no longer available'
      onButtonClick={() => {
        navigate('/dashboard');
      }}
    />
  );
};
